import ChapterHeader from "../detail/chapter-header"
import AccountThemeEditor from "./account-theme-editor-container"
import AdminAccountThemeEditor from "./admin-account-theme-editor-container"

//import AccountHeader from "./account-header-container"

const amountCellProps = {
	format  	: "0,0",
	language	: "fr-FR",
	type    	: "numeric",
	mantissa 	: 0
}

export default (scenarii, scenario, ppi, localAuthority, type, shownChapters, adminId=null, themes, consulted) => (() => {
	var rows = []

	var dico = []
	var currentChapter, dicoChapter
	var receiptsCount = 0
	const defaultReceiptsChapter = {
		label: "Non chapitrées",
		id: -1,
		number: 0
	}
	const defaultExpensesChapter = {
		label: "Non chapitrées",
		id: -2,
		number: 0
	}

	var accounts = []
	localAuthority.accounts.map(laca => {
		if (laca.account.receipts == laca.account.expense) {
			accounts.push(JSON.parse(JSON.stringify(laca)))
			accounts[accounts.length - 1].account.receipts = true
			accounts[accounts.length - 1].account.expense = false
			accounts.push(JSON.parse(JSON.stringify(laca)))
			accounts[accounts.length - 1].account.receipts = false
			accounts[accounts.length - 1].account.expense = true
		} else {
			accounts.push(laca)
		}
	})

	accounts = accounts.sort((a, b) => (a.account.number.toString() > b.account.number.toString() ? 1 : -1))

	if (adminId) {
		var themeIds = themes.map(t => t.id)
		var accountIds = scenario.themes.filter(t => (themeIds.indexOf(t.theme_id) !== -1)).map(t => t.account_id)
		accounts = accounts.filter(a => (accountIds.indexOf(a.account.id) !== -1))
	}

	const receipts = (type == "revenues")
	accounts.filter(a => (a.account.operation && ((receipts && a.account.receipts) || (!receipts && a.account.expense)))).map(account => {
		currentChapter = account.chapter
		if (!currentChapter) {
			currentChapter = account.account.receipts ? defaultReceiptsChapter : defaultExpensesChapter
		}
		if (!(dicoChapter = dico.find(c => (c.id == currentChapter.id)))) {
			dicoChapter = currentChapter
			dicoChapter.accounts = []
			dicoChapter.receipts = account.account.receipts
			dicoChapter.expense = account.account.expense
			dico.push(dicoChapter)

			if (account.account.receipts) receiptsCount++
		}

		dicoChapter.accounts.push(account.account)
	})

	dico = dico.sort((a, b) => {
		if (a.receipts) {
			if (b.receipts) return a.number.toString() > b.number.toString() ? 1 : -1
			else return -1
		}
		else {
			if (!b.receipts) return a.number.toString() > b.number.toString() ? 1 : -1
			else return 1
		}
	})

	var index = 0

	var editableCells = [], disableCells = []
	for (var i = 0 ; i < themes.length ; i++) {
		editableCells.push(i+3)
	}

	const chapterCellComponents = [
		{
			index: 0,
			component: ChapterHeader
		}
	]

	if (!adminId) {
		chapterCellComponents.push({
			consulted: consulted,
			indices: editableCells,
			component: AccountThemeEditor
		})
	}

	dico.map(chapter => {
		var scenarioChapter = scenario.chapters.find(c => (c.chapter_id == (chapter.id == -1 ? null : chapter.id)))
		rows.push({
			consulted: consulted,
			scenarii,
			scenario,
			chapter,
			accountsLength: chapter.accounts.length,
			accountIds: chapter.accounts.map(a => (a.id)),
			title: chapter.label,
			cellProps: amountCellProps,
			readOnly: true,
			amount: scenarioChapter ? scenarioChapter.amount : null,
			editableHeader: false,
			cellComponents: chapterCellComponents,
			index
		})
		index++

		if (shownChapters.indexOf(chapter.id) !== -1) {
			chapter.accounts.map(account => {
				var scenarioAccount = scenario.accounts.find(a => (a.account_id == account.id))
				var disableCells = [0, 1, 2]
				var adminEditableCells = []
				var validator
				//if (adminId) {
					for(var i=0; i<themes.length; i++) {
						validator = scenario.validated_themes.find(vt => vt.theme_id == themes[i].id)
						if (validator && validator.validated) {
							disableCells.push(i+3)
						} else if (!scenario.themes.find(t => (t.theme_id == themes[i].id && t.account_id == account.id))) {
								disableCells.push(i+3)
						} else {
							adminEditableCells.push(i+3)
						}
					}
				//}
				rows.push({
					consulted: consulted,
					scenarii,
					scenario,
					account,
					chapter,
					title: account.number + " - " + account.label,
					adminMode: adminId !== null,
					readOnly: !adminId,
					cellProps: amountCellProps,
					amount: scenarioAccount ? scenarioAccount.amount : null,
					disabledCells: adminId ? disableCells : [0, 1, 2],
					cellComponents: adminId ? [{ indices: adminEditableCells, component: AdminAccountThemeEditor }] : [
						/*
						{
							index: 0,
							component: AccountHeader
						},
						*/
						{
							indices: editableCells,
							component: AccountThemeEditor
						}
					],
					index
				})
				index++
			})
		}
	})

	if (!adminId) {
		rows.push({
			title: "Total",
			readOnly: true,
			cellProps: amountCellProps,
			className: "cat-footer",
		})
	}

	return {
		rows
	}
})()



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/scenario-table-defination.js